import { Filter } from 'vindi-ds-components';

import api from '@services/api';

import listData from '../../utils/list_data';

async function listChargesPending(params) {
  const request = await api.get('/admin/reports/charges_pending');

  const chargesPending = listData(request?.data.charges_pending, params);
  const data = request?.data.totals;

  return {
    ...data,
    chargesPending,
    totalCount: request?.data.charges_pending.length,
  };
}

function useFilterChargesPending() {
  const listing = Filter.useBrowserListing({
    queryOptions: {
      queryKey: 'charges-pending',
      queryFn: listChargesPending,
    },
    filterOptions: {
      pagination: {
        enabled: true,
        perPage: 20,
        getCount: async (query) => query?.data?.totalCount,
      },
    },
  });

  return {
    listing,
  };
}

export default useFilterChargesPending;
